// extracted by mini-css-extract-plugin
export var modal = "_5g-0";